import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { Container } from 'components/layout/Grid/'
import { headerTitleName } from 'utils/headerTitleName'
import MainLayout from 'components/MainLayout'
import IframeViewer from 'components/IframeViewer'
import { getPathName } from 'utils/getPathName'
import BackToAdminCentre from 'components/BackToAdminCentre'
import { notify } from 'utils/notification'
import constants from 'constants'

class DetailedReport extends Component {
  static propTypes = {
    currentReportURL: PropTypes.string.isRequired,
    dispatch: PropTypes.func.isRequired,
  }

  componentDidMount() {
    if (this.props.currentReportURL == null || this.props.currentReportURL === '') {
      this.props.dispatch(notify('Please select the report.'))
      const pathName = `${getPathName(this.props.currentUser, '/reports')}`
      this.props.history.push({ pathname: pathName })
    }
  }

  bannerProps = () => {
    const {
      routes, history, location, match, path,
    } = this.props
    return {
      name: headerTitleName(this.props.currentUser, 'Reports'),
      history,
      location,
      path,
      match,
      routes,
    }
  }

  render() {
    let reportUrl = `${constants.SSRS_BASEURL}${this.props.currentReportURL}`
    if (reportUrl.indexOf('BULeaderID={0}') > -1) {
      reportUrl = reportUrl.replace('{0}', this.props.currentUser.EmployeeId)
    }
    return (
      <div >
        <MainLayout
          bannerNavProps={{ ...this.bannerProps() }}
          sidebarType=""
        >
          <BackToAdminCentre displayText="Reports" isAdmin={this.props.currentUser.IsAdmin} />
          <Container>
            <div style={{ minWidth: '1270px' }}>
              <IframeViewer
                title="Reports"
                url={reportUrl}
              />
            </div>
          </Container>
        </MainLayout >
      </div >
    )
  }
}

const mapStateToProps = state => ({
  currentReportURL: state.reports.currentReportUrl,
})
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DetailedReport))



// WEBPACK FOOTER //
// ./src/containers/DetailedReport.js